'use client';
import React, { useState } from 'react';

import { TranslateTrigger } from './TranslateTrigger';
import { ProductDescription } from './ProductDescription';
import { Spacing } from '~/components';

import { productDescriptionRawOptions } from '../../../_queries/product-description-raw-options';
import { useGetProductDescriptionRaw } from '../../../_queries/useGetProductDescriptionRaw';

type Props = {
  pid: number;
  translatedDescription: string;
};

export const ProductDescriptionGroup = ({ pid, translatedDescription = '' }: Props) => {
  const [isTranslatedDescription, setIsTranslatedDescription] = useState(true);

  const { data } = useGetProductDescriptionRaw(productDescriptionRawOptions({ pid }, { enabled: Boolean(pid) }));

  const description = (!isTranslatedDescription ? data?.descriptionJp : translatedDescription) ?? '';

  return (
    <>
      <TranslateTrigger onTranslate={(isTranslated) => setIsTranslatedDescription(isTranslated)} />

      <Spacing height={30} />

      <ProductDescription values={{ description }} />
    </>
  );
};
